// Afastamento e inatividade (S-2230): PORTADO — tela real ligada ao BFF
// (collaborator/dashboard + history). Ver useAfastamentoStore / lib/afastamento.

// ── CBO — Classificação Brasileira de Ocupações ──────────────────────
// Análise CBO (Etapas/Classificação/Risco + tabela de trabalhadores) agora vem
// do BFF — ver src/stores/useCboStore.ts, src/lib/cbo.ts e src/services/ServiceCBO.js.

// ── Horários e jornada (análise) ─────────────────────────────────────
// Dashboards (Etapas/Classificação/Status), exposição ao risco e tabela de
// trabalhadores agora vêm do BFF — ver src/stores/useHorariosStore.ts,
// src/lib/jornada.ts e src/services/ServiceHorarios.js. A matriz de exposição
// (Prioridade × Impacto) abaixo permanece como referência estática do legado.

// matriz de exposição (Prioridade × Impacto) — fiel ao AGMatrizExposicaoTabela do legado
export const RISCO_COR: Record<string, { bg: string; fg: string }> = {
  INEXPRESSIVO: { bg: '#8189A6', fg: '#fff' },
  BAIXO: { bg: '#2F9E44', fg: '#fff' },
  MODERADO: { bg: '#F6C445', fg: '#7A5B00' },
  ELEVADO: { bg: '#F59E4B', fg: '#7A3E00' },
  CRITICO: { bg: '#E03131', fg: '#fff' },
};
export const RISCO_LABEL: Record<string, string> = {
  INEXPRESSIVO: 'Inexpressivo',
  BAIXO: 'Baixo',
  MODERADO: 'Moderado',
  ELEVADO: 'Elevado',
  CRITICO: 'Crítico',
};
// linhas = prioridade Alta→Nula; colunas = impacto Irrelevante→Crítico
export const matrizExposicao: string[][] = [
  ['ELEVADO', 'CRITICO', 'CRITICO', 'CRITICO'],
  ['MODERADO', 'ELEVADO', 'CRITICO', 'CRITICO'],
  ['BAIXO', 'MODERADO', 'ELEVADO', 'ELEVADO'],
  ['INEXPRESSIVO', 'MODERADO', 'ELEVADO', 'ELEVADO'],
];
export const matrizPrioridades = ['Alta', 'Média', 'Baixa', 'Nula'];
export const matrizImpactos = ['Irrelevante', 'Insignificante', 'Médio', 'Crítico'];
export const matrizLegendas = [
  {
    nivel: 'INEXPRESSIVO',
    texto:
      'Situação plenamente em conformidade com os requisitos legais e operacionais do eSocial, sem indícios de falhas ou inconsistências nos registros e envios.',
    tooltip:
      'Possibilidade remota de questionamentos administrativos ou judiciais, restrita a diferenças de interpretação da legislação ou entendimento de órgãos fiscalizadores, sem expectativa de impacto financeiro ou reputacional.',
  },
  {
    nivel: 'BAIXO',
    texto:
      'Risco com baixa probabilidade de materialização, mas que pode indicar oportunidades de melhoria nos processos internos de registro e envio de eventos do eSocial.',
    tooltip:
      'Pontos de atenção que não geram impacto direto imediato, mas que podem indicar fragilidades nos controles internos. Importante para conformidade e governança, mas sem repercussões legais automáticas.',
  },
  {
    nivel: 'MODERADO',
    texto:
      'Risco de questionamento individualizado, com potencial de materialização por meio de ações judiciais trabalhistas, denúncias formais ou fiscalizações pontuais motivadas por indícios ou reclamações específicas.',
    tooltip:
      'Trata-se de situações em que a irregularidade não é detectada automaticamente pelos sistemas governamentais, mas que pode gerar impacto financeiro e reputacional relevante caso confirmada.',
  },
  {
    nivel: 'ELEVADO',
    texto:
      'Risco com potencial de materialização a partir de fiscalizações ou auditorias (internas ou externas), que exigem a análise de documentos eletrônicos e físicos.',
    tooltip:
      'Demonstra falha nos registros eletrônicos, com alto potencial de responsabilização. Possibilidade de autuações, termos de ajustamento de conduta (TAC) e multas administrativas.',
  },
  {
    nivel: 'CRITICO',
    texto:
      'Risco de exposição imediata por meio do cruzamento automatizado de dados enviados ao eSocial e demais obrigações acessórias.',
    tooltip:
      'Indica potencial descumprimento da legislação trabalhista ou previdenciária, podendo acarretar em omissão ou erro em informações obrigatórias, geração automática de passivos tributários e multas e identificação automática pelos sistemas da Receita Federal, INSS ou Ministério do Trabalho.',
  },
];

// ── Horários e jornada ───────────────────────────────────────────────
export interface Jornada {
  [k: string]: unknown;
  id: number;
  trabalhador: string;
  turno: string;
  cargaSemanal: string;
  entrada: string;
  saida: string;
  intervalo: string;
}

// TODO: precisa de API — dados mockados removidos.
export const jornadasMock: Jornada[] = [];
